<template>
  <div :class="['socials', share ? 'socials--sharing' : '']">
    <template v-if="!share">    
      <a href="https://www.facebook.com/passement2jambes/" target="_blank">
        <i class="icon-facebook-logo-button"></i>
      </a>

      <a href="https://twitter.com/p2j_fr" target="_blank">
        <i class="icon-twitter-logo-button"></i>
      </a>

      <a href="https://www.youtube.com/channel/UC8aFW2H-00nsnzIajXw1sEg" target="_blank">
        <i class="icon-youtube-logotype"></i>
      </a>

      <a href="https://www.instagram.com/p2j_fr/" target="_blank">
        <i class="icon-instagram-logo"></i>
      </a>
    </template>

    <template v-if="share">
      <social-sharing url="http://transfertsdepekin.fr/#/" inline-template>
        <div>
          <network network="facebook">
            <i class="icon-facebook-logo-button"></i>
          </network>

          <network network="twitter">
            <i class="icon-twitter-logo-button"></i>
          </network>
        </div>
      </social-sharing>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'socials',
    props: [
      'share',
    ],
  };
</script>


<style lang="scss">
  .socials {
    padding-right: 20px;
    text-align: right;

    &.socials--sharing {
      display: block;
      margin-left: 10px;

      span ~ span {
        margin-left: 10px;
      }

      a:hover,
      span:hover {
        color: $orange;
      }
    }

    a,
    span {
      display: inline-block;
      color: $blue;
      text-decoration: none;
      vertical-align: middle;
      cursor: pointer;
      @include fontSize(29);
      @include defaultTransition(.4);

      ~ a {
        margin-left: 10px;
      }

      &:hover {
        color: $white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Socials.vue?c3883bba